import React from 'react';
import LiteralsService from 'src/services/literals/LiteralsService';
import H from 'history';
import SpendingLineGraphHeading from 'src/components/atomic/molecules/spendingLineGraphHeading/SpendingLineGraphHeading';
import { Formik } from 'formik';
import DateUtils from 'src/utils/date';
import SpendingLineGraphChart from 'src/components/atomic/molecules/spendingLineGraphChart/SpendingLineGraphChart';
import { ComparisonMonth } from 'src/types/comparisonMonth.enum';
import { SpendingLineGraphChartOption } from 'src/types/spendingLineGraph';

interface Props {
    title: string;
    propHistory?: H.History;
}

const SpendingLineGraph = ({ title, propHistory }: Props): JSX.Element => {
    const chartOptions: SpendingLineGraphChartOption[] = [
        {
            id: ComparisonMonth.LAST_MONTH,
            startDate: DateUtils.startDateOfLastMonth(),
            endDate: DateUtils.startDateOfThisMonth(),
            label: LiteralsService.getLiteral('Budget.Current.graph.lastMonth')
        },
        {
            id: ComparisonMonth.THIS_MONTH_LAST_YEAR,
            startDate: DateUtils.startDateOfThisMonthLastYear(),
            endDate: DateUtils.startDateOfThisMonthLastYear().plusMonths(1),
            label: LiteralsService.getLiteral('Budget.Current.graph.thisMonthLastYear')
        }
    ];

    return (
        <Formik initialValues={{ comparisonMonth: ComparisonMonth.LAST_MONTH }} enableReinitialize onSubmit={() => {}}>
            {({ values }) => {
                return (
                    <>
                        <SpendingLineGraphHeading chartOptions={chartOptions} propHistory={propHistory} />
                        <SpendingLineGraphChart
                            title={title}
                            comparisonMonthOption={chartOptions.find((option) => option.id === values.comparisonMonth)}
                        />
                    </>
                );
            }}
        </Formik>
    );
};

export default SpendingLineGraph;
